import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { EMPTY, empty, of, pipe, Subscription } from 'rxjs';
import { delay, distinctUntilChanged, map, switchMap, take, tap } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';
import * as authReducer from './reducers/index';
import { loadRedirectsNoCode, receivedMaxisToken } from './redirect.actions';

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.scss']
})
export class RedirectComponent implements OnInit, OnDestroy {

  isAuth$$: Subscription;
  url: string;

  constructor(
    private authService: AuthService,
    private router: Router,
    private store: Store,
    private route: ActivatedRoute) {
    route.queryParamMap
    .pipe(
      map(params => params.get('code')),
      tap(code => {
        if (code) {
          this.store.dispatch(receivedMaxisToken({code}));
        } else {
          this.store.dispatch(loadRedirectsNoCode());
        }
      }),
      take(1)
    ).subscribe(code => {
        this.url = localStorage.getItem('game360redirect');
        if (!code && !this.url) {
          console.log('code', code, 'url', this.url);
          this.router.navigate(['/homepage']);
        }
    });
  }

  ngOnInit(): void {
    this.getIsAuth();
    this.getIsConfirm();
  }

  getIsAuth() {
    let flag = true;
    this.isAuth$$ =
    this.store.select(authReducer.selectIsAuth)
    .subscribe(isAuth => {
      if (isAuth) {
        console.log('here');
        flag = false;
        if (this.url) {
          this.router.navigateByUrl(this.url);
        } else {
          this.router.navigate(['/homepage']);
        }
      }
    });
  }

  getIsConfirm() {

  }

  ngOnDestroy() {
    this.isAuth$$.unsubscribe();
  }

}
